module.exports = __webpack_public_path__ + "static/media/shortText.9d19804f.svg";